import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import moment from 'moment';
import 'element-ui/lib/theme-chalk/index.css';
import { post, get, getLonde} from './utils/http'
import './assets/css/base.css'   // 全局样式

import { Area } from 'vant';
import 'vant/lib/index.css';
import '@vant/touch-emulator';
Vue.use(Area);
Vue.use(ElementUI)
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
Vue.prototype.$moment = moment
Vue.config.productionTip = false
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$getLonde = getLonde
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
